import { larkYellow, mediumGrey } from '~/colors'

export default {
    column: {
        width: '200',
    },
    container: {
        backgroundColor: mediumGrey,
        paddingTop: '2%',
        paddingBottom: '1%',
        paddingLeft: '5%',
        paddingRight: '5%',
    },
    content: {
        alignSelf: 'center'
    },
    headerItem: {
        fontSize: '13',
        color: larkYellow,
        fontWeight: '600',
    },
    footerItem: {
        fontSize: '11',
        color: larkYellow,
        lineHeight: '2.5'
    },
    copyright: {
        borderTopWidth: 1, 
        borderColor: larkYellow,
        borderStyle: 'solid',
        paddingBottom: '10',
        paddingHorizontal: '15',
        paddingTop: '5',
        fontSize: '10',
        color: larkYellow,
    }
}



// WEBPACK FOOTER //
// ./src/views/Root/Footer/styles.js